import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetVideoQuery, usePostVideoMutation, useUpdateVideoMutation } from '../../features/video/videoApi';


const AddAssigMark = () => {

    const {id: videoId } = useParams()
    const [videoData, setVideoData] = useState({});

    const { data: getVideo, isLoading: getLoading, isError: getIsError, error: getError } = useGetVideoQuery(videoId, { skip: !videoId });
    const navigate = useNavigate();


    useEffect(() => {
        setVideoData({ ...getVideo, views: getVideo?.views?.slice(0, -1) })
    }, [getVideo])

    const handleChangeInput = (event) => {
        const { name, value } = event.target;
        setVideoData(prev => ({ ...prev, [name]: value }))
    }
    const [postVideoFunc, { isLoading, data, isSuccess, isError, error }] = usePostVideoMutation();
    const [updateVideoFunc, { isLoading: updateLoading, data: updateData, isSuccess: updateIsSuccess, isError: updateIsError, error: updateError }] = useUpdateVideoMutation();
    const handleSubmit = (e) => {
        e.preventDefault();

        if (videoId) {
            updateVideoFunc({ id: videoId, data: videoData })

        } else {

            postVideoFunc(videoData)
        }
    }
    useEffect(() => {
        if (isSuccess || updateIsSuccess) {
            navigate('/admin/videos')
        }
    }, [updateIsSuccess, isSuccess])

    return (
        <>

            <section className="py-6 bg-primary h-screen grid place-items-center">
                <div className="mx-auto max-w-md px-5 lg:px-0 " style={{ width: '600px' }}>
                    <div>

                        <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
                            Add Marks
                        </h2>
                    </div>
                    <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
                        <input type="hidden" name="remember" defaultValue="true" />
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="name" className="sr-only">Title</label>
                                <input onChange={handleChangeInput} id="name" value={videoData?.title} name="title" type="name" autoComplete="name" required className="login-input rounded-t-md" placeholder="Video Title" />
                            </div>

                            <div>
                                <label htmlFor="name" className="sr-only">Url</label>
                                <input onChange={handleChangeInput} id="name" value={videoData?.url} name="url" type="name" autoComplete="name" required className="login-input rounded-t-md" placeholder="Video Url" />
                            </div>
                            <div>
                                <label htmlFor="name" className="sr-only">Views</label>
                                <input onChange={handleChangeInput} id="name" value={videoData?.views} name="views" type="text" autoComplete="name" required className="login-input rounded-t-md" placeholder="Video Views" />
                            </div>
                            <div>
                                <label htmlFor="name" className="sr-only">Duration</label>
                                <input onChange={handleChangeInput} id="name" value={videoData?.duration} name="duration" type="name" autoComplete="name" required className="login-input rounded-t-md" placeholder="Video Duration" />
                            </div>
                            <div>
                                <label htmlFor="name" className="sr-only">Description</label>
                                <input onChange={handleChangeInput} id="name" name="description" value={videoData?.description} type="name" autoComplete="name" required className="login-input rounded-t-md" placeholder="Video Description" />
                                {/* <textarea/> */}
                            </div>

                        </div>
                        <div>
                            <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </section>

        </>
    )
}

export default AddAssigMark